import { useFetchMxfNestApi, useMxfNestToast } from "hooks";
import { getURLWithParams } from "utils/context";

export const useQuestoesChecklistList = (params = {}) => {
  const formatedParams = Object.fromEntries(
    Object.entries(params).filter(([, value]) => Boolean(value)),
  );
  return useFetchMxfNestApi(getURLWithParams("/questionario", formatedParams));
};

export const useQuestoesChecklistToast = (id = null) => {
  const { onSend } = useMxfNestToast();

  const onCreate = async data => {
    const endpoint = id ? `/questionario/${id}` : `/questionario`;
    const type = id ? "PATCH" : "POST";

    return onSend({
      endpoint,
      messageSuccess: id
        ? "Questão atualizada com sucesso"
        : "Questão cadastrada com sucesso",
      messageFail: id
        ? "Falha ao atualizar questão"
        : "Não foi possível cadastrar a questão",
      data,
      type,
    });
  };

  const onRemove = async () =>
    onSend({
      endpoint: `/questionario/${id}`,
      messageSuccess: "Questão removida com sucesso",
      messageFail: "Não foi possível remover a questão",
      type: "DELETE",
    });

  return { onCreate, onRemove };
};
